import { LanguageOption } from '../types/types';

const LanguageOptions: LanguageOption[] = [
	{ labelId: 'LanguageOptions.english', value: 'en' },
	// { labelId: 'LanguageOptions.arabic', value: 'ar' },
	// { labelId: 'LanguageOptions.danish', value: 'da' },
	// { labelId: 'LanguageOptions.german', value: 'de' },
	// { labelId: 'LanguageOptions.chinese', value: 'zh' },
];

export default LanguageOptions;
